<template>
  <b-row
    align-v="center"
    class="m-0 p-0 header-units"
  >
    <b-col>
      <p class="c" />
    </b-col>
    <b-col>
      <p class="header_config">
        Input
      </p>
    </b-col>
    <b-col>
      <p class="header_config">
        Output
      </p>
    </b-col>
    <b-col>
      <p class="header_config">
        Log
      </p>
    </b-col>
  </b-row>
</template>

<script>
export default {
}
</script>

<style>
.header-units{
  font-size: 0.8rem;
  font-weight: bold;
}
.header_config{
  margin: 0 !important;
  padding: 0 !important;
      display: flex !important;
    /* align-items: center; */
    background-color: transparent !important;
    box-shadow: none !important;
    
    height: 1.2rem !important;
    opacity: 0.96;
    position: relative !important;
    /* padding: 0 153px; */
    /* position: fixed; */
    width: 100% !important;
    justify-content: space-between;
}
</style>